<script>
    import {fly} from 'svelte/transition';
</script>

<div class="center">
    <div class="img_wrapper">
        <img src="/images/draper_logo.svg" in:fly alt="Draper logo" />
    </div>
</div>

<style>
    .center {
        position: relative;
        animation: loader 1.5s 0s infinite;
    }
    .img_wrapper {
        width: fit-content;
        margin: auto;
        margin-top: 20vw;
    }
    @keyframes loader{
        0%{
            opacity: 0%;
        }
        50%{
            opacity: 100%;
        }
        100%{
            opacity: 0%;
        }
    }
</style>
